export enum Errors {
  GENERIC_ERROR = 'Sorry, there was an issue with your request. Please try again.',
  API_ERROR = 'We were unable to action your request. Please try again.',
  SIGNIN_ERROR = 'We were unable to email you a verification code. Please try again.',
  VERIFY_ERROR = 'We were unable to verify your email. Please try again.',
}
